// File: /src/components/PasswordUpdateForm.js

import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';

function PasswordUpdateForm({
	userData,
	passwordError,
	handleChange,
	handlePasswordSubmit,
}) {
	const [showCurrentPassword, setShowCurrentPassword] = useState(false);
	const [showNewPassword, setShowNewPassword] = useState(false);
	const [showConfirmPassword, setShowConfirmPassword] = useState(false);

	return (
		<div className="password-update-section">
			<h2>Atualizar Senha</h2>
			<form
				onSubmit={handlePasswordSubmit}
				className="user-account-form"
				autoComplete="off"
			>
				<div className="form-row">
					<label>
						Senha Atual:
						<div className="password-input-wrapper">
							<input
								type={showCurrentPassword ? 'text' : 'password'}
								name="currentPassword"
								value={userData.currentPassword || ''}
								onChange={handleChange}
								placeholder="Digite sua senha atual"
								autoComplete="off"
							/>
							<span
								className="password-toggle-icon"
								onClick={() =>
									setShowCurrentPassword(!showCurrentPassword)
								}
							>
								{showCurrentPassword ? (
									<EyeOff size={20} />
								) : (
									<Eye size={20} />
								)}
							</span>
						</div>
					</label>
				</div>

				<div className="form-row">
					<label>
						Nova senha:
						<div className="password-input-wrapper">
							<input
								type={showNewPassword ? 'text' : 'password'}
								name="password"
								value={userData.password || ''}
								onChange={handleChange}
								placeholder="Digite sua nova senha"
								autoComplete="off"
							/>
							<span
								className="password-toggle-icon"
								onClick={() =>
									setShowNewPassword(!showNewPassword)
								}
							>
								{showNewPassword ? (
									<EyeOff size={20} />
								) : (
									<Eye size={20} />
								)}
							</span>
						</div>
					</label>
				</div>

				<div className="form-row">
					<label>
						Repita a senha:
						<div className="password-input-wrapper">
							<input
								type={showConfirmPassword ? 'text' : 'password'}
								name="confirmPassword"
								value={userData.confirmPassword || ''}
								onChange={handleChange}
								placeholder="Repita sua nova senha"
								autoComplete="off"
							/>
							<span
								className="password-toggle-icon"
								onClick={() =>
									setShowConfirmPassword(!showConfirmPassword)
								}
							>
								{showConfirmPassword ? (
									<EyeOff size={20} />
								) : (
									<Eye size={20} />
								)}
							</span>
						</div>
					</label>
					{passwordError && (
						<p style={{ color: 'red', fontSize: '0.9rem' }}>
							{passwordError}
						</p>
					)}
				</div>

				<div className="form-row">
					<button type="submit">Salvar Senha</button>
				</div>
			</form>
		</div>
	);
}

export default PasswordUpdateForm;
